/**
 * Map Service
 * Handles pure logic functionality related to map display and path visualization
 */


export const getVisiblePaths = (currentMode, autoPath, customPath) => {
  if (currentMode === 'Comparison Mode') {
    // Comparison mode shows both paths
    return {
      auto: autoPath,
      custom: customPath
    };
  } else if (currentMode === 'Auto Find Path') {
    // Auto mode only shows auto path
    return {
      auto: autoPath
    };
  } else if (currentMode === 'Custom Path') {
    // Custom mode only shows custom path
    return {
      custom: customPath
    };
  }
  // Default: don't show any paths
  return {};
};


export const shouldShowAutoPath = (currentMode) => {
  return currentMode === 'Auto Find Path' || currentMode === 'Comparison Mode';
};


export const shouldShowCustomPath = (currentMode) => {
  return currentMode === 'Custom Path' || currentMode === 'Comparison Mode';
};

export const shouldShowUnfinishedPath = (currentMode) => {
  // Only show unfinished path in Custom Path mode
  return currentMode === 'Custom Path';
};

export const shouldShowDistanceLabels = (currentMode) => {
  // Show distance labels in specific modes
  return currentMode === 'Auto Find Path' || 
         currentMode === 'Custom Path' || 
         currentMode === 'Comparison Mode';
};

export const getMapContainerClassName = (currentMode, setupSubmode) => {
  let className = "map-container";
  
  // Only show crosshair cursor in "Setup Path Points" mode's "Map Point Marking" submode
  if (currentMode === 'Setup Path Points' && setupSubmode === 'Map Point Marking') {
    className += " map-point-mode";
  }
  
  // Add pointer cursor in custom path mode
  if (currentMode === 'Custom Path') {
    className += " map-custom-mode";
  }
  
  return className;
};

export const isMapClickAddPointEnabled = (currentMode, setupSubmode) => {
  return currentMode === 'Setup Path Points' && setupSubmode === 'Map Point Marking';
};

export const isPointSelectionEnabled = (currentMode) => {
  return currentMode === 'Custom Path';
}; 